<div class="space-y-3">

    <p class="text-xs mt-2 text-gray-500 dark:text-gray-400">
        {{ rbacScope.scopeLabel() }} - manage roles and assign permissions for this portal.
    </p>

    <app-list-module-surface
        [config]="listSurfaceConfig"
        [filters]="listFilters"
        [deletedView]="view === 'deleted'"
        [errorMessage]="errorMessage"
        [loading]="loading"
        [meta]="meta"
        [rowCount]="roles.length"
        (filtersChange)="onListFiltersChange($event)"
        (pageChange)="onListPageChange($event)"
    >
        <div toolbarFiltersExtra class="flex flex-wrap gap-2" role="tablist" aria-label="Role list">
            <button type="button" (click)="setView('active')"
                class="flex items-center rounded-full px-4 py-2 text-sm font-medium transition-colors"
                [ngClass]="
                    view === 'active'
                        ? 'bg-[#FFD85F] text-black shadow-sm dark:bg-[#e8c44a] dark:text-black'
                        : 'border border-gray-200 bg-white text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-gray-200 dark:hover:bg-white/5'
                ">
                Active
            </button>
            <button type="button" (click)="setView('deleted')"
                class="flex items-center rounded-full px-4 py-2 text-sm font-medium transition-colors"
                [ngClass]="
                    view === 'deleted'
                        ? 'bg-[#FFD85F] text-black shadow-sm dark:bg-[#e8c44a] dark:text-black'
                        : 'border border-gray-200 bg-white text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-gray-200 dark:hover:bg-white/5'
                ">
                Deleted
            </button>
        </div>

        <ng-container toolbarActions>
            @if (view === 'active' && (P.ROLE_ADD | hasPermission)) {
            <button type="button"
                class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-black shadow-none hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
                (click)="openAddModal()">
                <icon-plus-circle class="size-5" />
                <span>Add New Role</span>
            </button>
            }
        </ng-container>

        <app-manage-roles-table
            listTable
            [rows]="roles"
            [view]="view"
            [loading]="loading"
            [emptyMessage]="emptyMessage"
            [openActionMenuKey]="openActionMenuKey"
            [sortColumn]="sortColumn"
            [sortDirection]="sortBy"
            (sortChange)="onTableSort($event)"
            (toggleMenu)="toggleActionMenu($event.key, $event.event)"
            (closeMenu)="closeActionMenu()"
            (edit)="menuEdit($event)"
            (delete)="menuDelete($event)"
            (permanentDelete)="confirmPermanentDelete($event)"
            (restore)="menuRestore($event)"
            (toggleStatus)="menuToggleStatus($event)"
            (managePermissions)="menuManagePermissions($event)"
        />
    </app-list-module-surface>

<!-- Add modal -->
<div *ngIf="showAddModal" class="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 px-4"
    (click)="closeAddModal()" (keydown.escape)="closeAddModal()">
    <div class="relative w-full max-w-md rounded-2xl bg-white dark:bg-[#0e1726] shadow-xl"
        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <div class="flex items-center justify-between border-b border-gray-100 dark:border-[#191e3a] px-6 py-4">
            <h3 class="text-base font-semibold text-gray-900 dark:text-white">Add New Role</h3>
            <button type="button" (click)="closeAddModal()"
                class="rounded-lg border border-gray-200 dark:border-[#191e3a] p-1.5 text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10">
                <icon-x class="size-4" />
            </button>
        </div>
        <form [formGroup]="addForm" (ngSubmit)="submitAdd()" class="px-6 py-5 space-y-4">
            <div *ngIf="modalError()" class="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">{{ modalError() }}
            </div>
            <div>
                <label for="add-role-name" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Role Name <span
                        class="text-danger">*</span></label>
                <input id="add-role-name" type="text" formControlName="role_name" (input)="onAddRoleNameChange()"
                    placeholder="Enter role name" class="form-input w-full rounded-lg" />
            </div>
            <div>
                <label for="add-role-slug" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Role Slug <span
                        class="text-danger">*</span></label>
                <input id="add-role-slug" type="text" formControlName="slug" placeholder="Enter role slug"
                    class="form-input w-full rounded-lg" />
            </div>
            <div>
                <label for="add-role-description" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Description</label>
                <textarea id="add-role-description" formControlName="description" rows="3" placeholder="Optional description"
                    class="form-textarea w-full rounded-lg resize-none"></textarea>
            </div>
            <div class="flex justify-end gap-3 pt-1">
                <button type="button" (click)="closeAddModal()"
                    class="rounded-lg border border-gray-200 dark:border-[#191e3a] px-5 py-2 text-sm font-medium">Cancel</button>
                <button type="submit" [disabled]="addLoading()"
                    class="btn rounded-full bg-[#303030] px-8 font-semibold text-white shadow-lg disabled:cursor-not-allowed disabled:opacity-60">
                    {{ addLoading() ? 'Savingâ€¦' : 'Save' }}
                </button>
            </div>
        </form>
    </div>
</div>

<!-- Edit modal -->
<div *ngIf="showEditModal" class="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 px-4"
    (click)="closeEditModal()" (keydown.escape)="closeEditModal()">
    <div class="relative w-full max-w-md rounded-2xl bg-white dark:bg-[#0e1726] shadow-xl"
        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <div class="flex items-center justify-between border-b border-gray-100 dark:border-[#191e3a] px-6 py-4">
            <h3 class="text-base font-semibold text-gray-900 dark:text-white">Edit Role</h3>
            <button type="button" (click)="closeEditModal()"
                class="rounded-lg border border-gray-200 dark:border-[#191e3a] p-1.5 text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10">
                <icon-x class="size-4" />
            </button>
        </div>
        <form [formGroup]="editForm" (ngSubmit)="submitEdit()" class="px-6 py-5 space-y-4">
            <div *ngIf="modalError()" class="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">{{ modalError() }}
            </div>
            <div>
                <label for="edit-role-name" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Role Name <span
                        class="text-danger">*</span></label>
                <input id="edit-role-name" type="text" formControlName="role_name" class="form-input w-full rounded-lg" />
            </div>
            <div>
                <label for="edit-role-slug" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Role Slug <span
                        class="text-danger">*</span></label>
                <input id="edit-role-slug" type="text" formControlName="slug" class="form-input w-full rounded-lg" />
            </div>
            <div>
                <label for="edit-role-description" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Description</label>
                <textarea id="edit-role-description" formControlName="description" rows="3"
                    class="form-textarea w-full rounded-lg resize-none"></textarea>
            </div>
            <div class="flex justify-end gap-3 pt-1">
                <button type="button" (click)="closeEditModal()"
                    class="rounded-lg border border-gray-200 dark:border-[#191e3a] px-5 py-2 text-sm font-medium">Cancel</button>
                <button type="submit" [disabled]="editLoading()"
                    class="rounded-lg bg-[#18214d] px-5 py-2 text-sm font-medium text-white disabled:opacity-60 dark:bg-[#303030]">
                    {{ editLoading() ? 'Updatingâ€¦' : 'Update' }}
                </button>
            </div>
        </form>
    </div>
</div>

<app-delete-confirm-modal
    [open]="showDeleteModal"
    [heading]="deleteModalHeading"
    [entityName]="selectedRole?.role_name ?? ''"
    entityNoun="role"
    [variant]="deleteVariant"
    [loading]="deleteLoading()"
    [error]="modalError() ?? ''"
    (cancelled)="closeDeleteModal()"
    (confirmed)="submitDelete()"
/>

<app-restore-confirm-modal
    [open]="showRestoreModal"
    heading="Restore role?"
    [entityName]="selectedRole?.role_name ?? ''"
    activeListLabel="active role list"
    [loading]="restoreLoading()"
    (cancelled)="closeRestoreModal()"
    (confirmed)="submitRestore()"
/>
</div>
